module.exports = __webpack_public_path__ + "img/logo.dc71af02.png";